import React from "react";
import { buildClasses } from "../utils/buildClasses";

export function AuthStrategyButton(props: {
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
}): JSX.Element {
  return (
    <button
      className={buildClasses(
        "w-full",
        "border",
        // The panels' warm outline, a little stronger for a control.
        "border-edge/[0.2]",
        "rounded-md",
        "px-4",
        "py-2",
        "relative",
        "hover:bg-surface-300",
        "transition-all",
      )}
      onClick={props.onClick}
    >
      <Icon icon={props.icon} />
      {props.text}
    </button>
  );
}

function Icon(props: { icon: React.ReactNode }): JSX.Element {
  return <div className={buildClasses("absolute", "left-4")}>{props.icon}</div>;
}
